<!--
 * @Date: 2023-05-18 17:31:12
 * @LastEditTime: 2024-06-17 10:22:25
-->
<template>
  <div class="contact_box">
    <template v-for="contact in contacts" :key="contact.id">
      <a-tooltip placement="left" v-if="contact.phone" :title="contact.phone">
        <div
          class="contact"
          @click="go2page(contact)"
          @mouseenter="contact.isActive = true"
          @mouseleave="mouseleave"
        >
          <img :src="contact.icon" class="icon" />
          <p class="name">{{ contact.name }}</p>
          <template v-if="VUE_APP_GAME != 'sdszsy' && contact.code">
            <div class="show_box" v-show="contact.isActive">
              <img class="code" :src="contact.code" v-if="contact.code" />
              <p
                :class="['text', { special_text: contact.isSpecial }]"
                v-html="contact.text"
              ></p>
            </div>
          </template>
        </div>
      </a-tooltip>
      <div
        class="contact"
        v-else-if="contact.type && contact.type == 'dropdown'"
      >
        <a-dropdown placement="bottom" :trigger="['click']">
          <div style="display: flex; align-items: center; width: 100%">
            <img :src="contact.icon" class="icon" />
            <p class="name">{{ contact.name }}</p>
            <img src="@/assets/drop.png" class="icon_drop" />
          </div>
          <template #overlay>
            <a-menu>
              <a-menu-item v-for="(data, index) in contact.detailsList" :key="index">
                <a
                  class="a_link"
                  target="_blank"
                  rel="noopener noreferrer"
                  :href="data.link"
                >
                  {{ data.text }}
                </a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
      <div
        class="contact"
        @click="go2page(contact)"
        @mouseenter="contact.isActive = true"
        @mouseleave="mouseleave"
        v-else
      >
        <img :src="contact.icon" class="icon" />
        <p class="name">{{ contact.name }}</p>
        <template v-if="VUE_APP_GAME != 'sdszsy' && contact.code">
          <div class="show_box" v-show="contact.isActive">
            <img class="code" :src="contact.code" v-if="contact.code" />
            <p
              :class="['text', { special_text: contact.isSpecial }]"
              v-html="contact.text"
            ></p>
          </div>
        </template>
      </div>
    </template>
    <a-modal v-model:visible="visible" title="公告" @ok="onHandleOk" :footer="null">
      <div class="announcement">在2026年3月29日的赛事中，由于服务器负载异常临时取消小程序监考，并推迟了Scratch图形化编程小学低年级组场次考试时间，因此带来的不便请谅解。由于该原因导致缺失第三视角监考数据的不会影响作答成绩。</div>
    </a-modal>
    
  </div>
</template>

<script setup>
import { reactive, watchEffect,ref } from "vue";

let { VUE_APP_GAME } = process.env;
const visible = ref(false)
const contacts = reactive([]),
  mouseleave = () => {
    const cache = [...contacts];
    contacts.length = 0;
    cache.forEach((contact) => {
      contact.isActive = false;
      contacts.push(contact);
    });
  },
  go2page = (e) => {
    // 有链接就跳转，没链接不处理
    if (e.link) {
      const link = document.createElement("a");
      link.href = e.link;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
    }
    if(e.isDialog){
      visible.value = true
    }
  };

  const onHandleOk = ()=>{
    visible.value = false
  }
  const onClose = ()=>{
    visible.value = false

  }

watchEffect(() => {
  let arr = [];
  if (VUE_APP_GAME == "sdszsy")
    arr = [
      {
        id: 0,
        name: "平台使用说明",
        text: "平台使用说明",
        link: "https://doc.weixin.qq.com/doc/w3_AIQAJAaZAFoQbxofJhCSQaqA7UFdU?scode=APYANQezABAlwr0y6xAIQAJAaZAFo",
        icon: require("@/assets/contact/eventRules.png"),
        // code: require('@/assets/contact/instructions.png'),
        isActive: false,
      },
    ];
  else if (VUE_APP_GAME == "hdycp")
    arr = [
      {
        id: 1,
        name: "赛事规则",
        text: "扫码获取参赛报名表和承诺书",
        icon: require("@/assets/contact/eventRules.png"),
        code: require("@/assets/contact/hdycp/rule.png"),
        isActive: false,
      },
    ];
  else
    arr = [
      {
        id: 0,
        name: "平台使用说明",
        text: "平台使用说明",
        icon: require("@/assets/contact/eventRules.png"),
        link: "https://docs.qq.com/doc/p/a4d57810f842f10c1532eb6bfbc8f37298f24eb3",
        // code: require('@/assets/contact/instructions.png'),
        isActive: false,
      },
      // {
      //   id: 1,
      //   name: "赛事规则",
      //   type: "dropdown",
      //   text: "赛事规则",
      //   detailsList: [
      //     {
      //       text: '软件编程赛',
      //       link: 'https://cdn.codedancing.cn/registration/upload/normalFiles/20250330/175521Yw09mvK6YrLryRs.pdf',
      //     },
      //     {
      //       text: 'AIGC数字创意设计',
      //       link: 'https://cdn.codedancing.cn/registration/upload/normalFiles/20250416/105359Ou3uw3TBMHehHGf.pdf',
      //     },
      //     {
      //       text: '华工创意搭建赛',
      //       link: 'https://cdn.codedancing.cn/registration/upload/normalFiles/20250711/101347ktr3s5ZthxqcomM.pdf',
      //     },
      //     {
      //       text: '奇趣小记者科创作文',
      //       link: 'https://cdn.codedancing.cn/registration/upload/normalFiles/20250630/100117lNHx9fOwnTxUVto.pdf',
      //     },
      //   ],
      //   icon: require("@/assets/contact/eventRules.png"),
      //   // code: require("@/assets/contact/qck/rule.png"),
      //   link: "https://docs.qq.com/doc/p/c40d95d674a7ce4c29e0ea00925e2be72cfda17c?nlc=1",
      //   isActive: false,
      // },
      {
        id: 2,
        name: "赛事咨询",
        text: "赛事咨询",
        icon: require("@/assets/contact/consultation.png"),
        // code: require('@/assets/contact/qck/consulting.png'),
        phone: 18588008028,
        isActive: false,
      },
      // {
      //   id: 3,
      //   name: "比赛时间表",
      //   text: "比赛时间表",
      //   type: "dropdown",
      //   icon: require("@/assets/contact/eventRules.png"),
      //   detailsList: [
      //     {
      //       text: '软件编程赛',
      //       link: 'https://docs.qq.com/doc/p/abf78c469a554ed615d06068a14f95baeeaebd09',
      //     },
      //     {
      //       text: 'AIGC数字创意设计',
      //       link: 'https://docs.qq.com/doc/p/6dd7bd27cfb416a6928d456e80cbc0b8d94da1da',
      //     },
 
      //   ],
      //   link: "https://docs.qq.com/doc/p/abf78c469a554ed615d06068a14f95baeeaebd09",
      //   // code: require('@/assets/contact/instructions.png'),
      //   isActive: false,
      // },
      // {
      //   id: 3,
      //   name: '赛事通知群 1',
      //   text: '华工软件编程挑战赛通知群1<br/>QQ群号: 463737040',
      //   icon: require('@/assets/contact/notificationGroup.png'),
      //   code: require('@/assets/contact/qck/1.png'),
      //   isActive: false,
      //   isSpecial: true,
      // },
      // {
      //   id: 4,
      //   name: '赛事通知群 2',
      //   text: '华工软件编程挑战赛通知群2<br/>QQ群号: 615294745',
      //   icon: require('@/assets/contact/notificationGroup.png'),
      //   code: require('@/assets/contact/qck/2.png'),
      //   isActive: false,
      //   isSpecial: true,
      // },
      // {
      //   id: 5,
      //   name: '赛事通知群 3',
      //   text: '华工软件编程挑战赛通知群3<br/>QQ群号: 592900132',
      //   icon: require('@/assets/contact/notificationGroup.png'),
      //   code: require('@/assets/contact/qck/3.png'),
      //   isActive: false,
      //   isSpecial: true,
      // },
      // {
      //   id: 6,
      //   name: '技术咨询',
      //   text: `
      //   <ul style="list-style-type: none">
      //     <li style="line-height: 0.125rem;">技术咨询QQ：529750028</li>
      //   </ul>`,
      //   // <li style="line-height: 0.125rem;">技术咨询电话：18666717012</li>
      //   // <li style="line-height: 0.125rem;">技术咨询电话：13535088091</li>
      //   icon: require('@/assets/contact/consultation.png'),
      //   isActive: false,
      //   isSpecial: true,
      // },
            {
        id: 6,
        name: "公告",
        text: "公告",
        icon: require("@/assets/login/announcement.svg"),
        isDialog: true,
        phone: '',
        isActive: false,
      },
    ];

  arr.forEach((item) => {
    contacts.push(item);
  });
});
</script>

<style lang="less" scoped>
.contact_box {
  height: fit-content;
  padding: 16px;
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  // bottom: 392px;
  right: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px;

  .contact {
    min-width: 164px;
    height: 40px;
    background: #0052d9;
    border-radius: 4px;
    padding: 0 16px;
    // padding-left: 16px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:not(:first-of-type) {
      // margin-top: 8px;
    }

    .icon {
      width: 28px;
      height: 28px;
    }
    .icon_drop {
      width: 18px;
      height: 18px;
      margin-left: auto;
    }

    .name {
      height: 28px;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.9);
      line-height: 28px;
      margin-left: 8px;
    }

    .show_box {
      width: fit-content;
      min-width: 248px;
      height: fit-content;
      padding: 8px 4px 10px 4px;
      box-sizing: border-box;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      top: 0;
      left: -256px;

      .code {
        width: 240px;
        height: 240px;
      }

      .text {
        text-align: center;
        margin-top: 8px;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.9);
        line-height: 24px;

        &.special_text {
          margin-top: 2px;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.9);
          line-height: 20px;
        }
      }
    }
  }
}
.a_link {
  font-size: 16px !important;
}
:deep(.ant-dropdown-menu-item:hover, .ant-dropdown-menu-submenu-title:hover) {
  background-color: #8bb8ff !important;
}
:deep(.ant-dropdown-menu-title-content) {
  padding: 4px 16px !important;
}
.announcement{
  padding: 0 16px 24px;
}
</style>
